import { render } from "./VariableChip.vue?vue&type=template&id=629b4c7e"
import script from "./VariableChip.vue?vue&type=script&lang=js"
export * from "./VariableChip.vue?vue&type=script&lang=js"

import "./VariableChip.vue?vue&type=style&index=0&id=629b4c7e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/VariableChip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "629b4c7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('629b4c7e', __exports__)) {
    api.reload('629b4c7e', __exports__)
  }
  
  module.hot.accept("./VariableChip.vue?vue&type=template&id=629b4c7e", () => {
    api.rerender('629b4c7e', render)
  })

}


export default __exports__